//
//
//
//
//
//
//
//
//
//
//
import studentList from "./student-list.vue";
import capabilityLabel from "./capability-label.vue";
export default {
  name: "teammanage",
  components: {
    studentList: studentList,
    capabilityLabel: capabilityLabel
  },
  props: ['teamId'],
  data: function data() {
    return {
      activeIndex: 'studentList'
    };
  },
  created: function created() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};